import { selectActiveFeature } from '../../../Map/selectors';
import { TThunkAction } from '../../types/redux';
import { setSelectedFeature } from '../selectFeature/selectFeature';
import { updateFeatureProperties } from '../updateFeatureProperties/updateFeatureProperies';

export function unselectFeature(): TThunkAction {
  return (dispatch, getState) => {
    const activeFeature = selectActiveFeature(getState());

    dispatch(setSelectedFeature(null));

    if (!activeFeature) {
      return;
    }

    dispatch(
      updateFeatureProperties({
        featureId: activeFeature.id,
        precision: activeFeature.precision,
        properties: { isActive: false },
      }),
    );
  };
}
